import { render } from "./Welcome.vue?vue&type=template&id=27b4edc4&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=27b4edc4&scoped=true&lang=css"

import exportComponent from "/var/www/dmp/releases/1776447385/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b4edc4"]])

export default __exports__